import axios from 'axios';

// Patches the shared `axios` default export (the same object every page imports
// via `import axios from 'axios'`), so every existing call site gets the
// Authorization header and 401 handling below with no per-file changes.
// Imported once, for its side effect, in src/index.js before the app renders.

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const storedUser = JSON.parse(localStorage.getItem('authUser') || 'null');
      const isTechnician = storedUser?.role === 'technician';
      const loginPath = isTechnician ? '/login/technician' : '/login';

      localStorage.removeItem('authToken');
      localStorage.removeItem('authUser');
      localStorage.removeItem('authExpiration');

      if (window.location.pathname !== loginPath) {
        window.location.href = loginPath;
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
